import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateAnn(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateAnn({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('EMAnoticeApi.getAnoticelist', id)
          .then((json) => {
            commit('updateAnn', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
